import { Column, ColumnCenter, Row, RowCenter } from "style/preset";
import StyledContainer from "style/styledContainer";
import styled from "styled-components";

import { ReactComponent as ArrowDownSvg } from 'assets/svgs/arrow_down.svg'
import ImgCom, { ImgOutWrap } from "../ImgCom";
import useWin from "hooks/useWin";
import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks";
import { ChaingeChain, ChaingeToken, ChaingeTokenChain } from "types/baseType";
import { setFromChain, setToChain } from "hooks/redux/slices/coreInfoSlice";
import useChainsForToken from "hooks/useChainsForToken";
import useFormatToken from "hooks/useFormatToken";
import { setTokenChainsFrom, setTokenChainsTo } from "hooks/redux/slices/appSlice";
import CImage from "../CImage";
import DrawerAssetsBrc20Com from "./Drawer/DrawerAssetsBrc20Com";
import DrawerChainsBrc20Com from "./Drawer/DrawerChainsBrc20Com";
interface Props {
    label: string
    direction: string

    isBrc20?: boolean

    chainDetail?: ChaingeChain
    tokenDetail?: ChaingeToken
}

const AssetsSelectBrc20Com = ({label, direction, chainDetail, isBrc20 = false, tokenDetail}: Props) => {
    const { tokenChainsFrom, tokenChainsTo, chainsByBrc20 } = useAppSelector((state) => state.app)
    const { chainsByToken } = useChainsForToken()
    const { formatToken } = useFormatToken()
    const { open: assetsOpen, winOpenChange: winOpenChangeByAssets } = useWin()
    const { open: chainsOpen, winOpenChange: winOpenChangeByChains } = useWin()
    const dispatch = useAppDispatch()

    const fnChosedChain = useCallback((chain: ChaingeChain) => {
        if(direction === 'from') {
            dispatch(setFromChain(chain))
        } else {
            dispatch(setToChain(chain))
        }
    }, [direction, dispatch])

    const fnChosedToken = useCallback((token: ChaingeTokenChain) => {
        chainsByToken(token, direction, chainsByBrc20)
        if(direction === 'from') {
            dispatch(setTokenChainsFrom(token))
        } else {
            dispatch(setTokenChainsTo(token))
        }
        formatToken(token, chainDetail as ChaingeChain, direction)
    }, [chainDetail, chainsByBrc20, chainsByToken, direction, dispatch, formatToken])

    useEffect(() => {
        if(!tokenChainsFrom || !tokenChainsTo) return
        if(direction === 'from') {
            formatToken(tokenChainsFrom, chainDetail as ChaingeChain, direction)
        } else {
            formatToken(tokenChainsTo, chainDetail as ChaingeChain, direction)
        }
    }, [tokenChainsFrom, chainDetail, direction, tokenChainsTo, formatToken])

    return <AssetsSelectWrap>
        <LeftWrap>
            {
                isBrc20 && <StyledContainer $height="48px" $fontSize="14px" $lineHeight="48px" $ml="10px" $mr="48px">Select destination chain</StyledContainer>
            }
            {
                !isBrc20 &&  <>
                    <StyledContainer $width="30px" $fontSize="14px" $lineHeight="16px" $ml="10px" $mr="48px">{label}</StyledContainer>
                    <RowCenter $pointer onClick={() => winOpenChangeByAssets(true)}>
                        <ImgCom imgUrl={tokenDetail?.imgUrl as string}></ImgCom>
                        <Column $ml="10px" $alignItems="flex-start">
                            <Row>
                                <StyledContainer $fontSize="16px" $lineHeight="18px">{tokenDetail?.symbol}</StyledContainer>
                                <StyledContainer $width="6px"></StyledContainer>
                                <ArrowDownSvgWrap></ArrowDownSvgWrap>
                            </Row>
                            <StyledContainer $fontSize="12px" $lineHeight="14px" $roobertRegular>{tokenDetail?.name}</StyledContainer>
                        </Column>
                    </RowCenter>
                </>
            }
        </LeftWrap>

        <RightWrap onClick={() => winOpenChangeByChains(true)}>
            <Row>
                <CImage width="22px" height="22px" src={chainDetail?.imgUrl as string}></CImage>
                <StyledContainer $width="6px"></StyledContainer>
                <ArrowDownSvgWrap></ArrowDownSvgWrap>
            </Row>
            <StyledContainer $mt="8px" $fontSize="12px" $lineHeight="14px">On {chainDetail?.fullName}</StyledContainer>
        </RightWrap>

        {/* 选择资产 */}
        <DrawerAssetsBrc20Com open={assetsOpen} closeChange={(isClosed) => winOpenChangeByAssets(isClosed)} onComplete={fnChosedToken}></DrawerAssetsBrc20Com>
        
        {/* 选择链 */}
        <DrawerChainsBrc20Com direction={direction} open={chainsOpen} closeChange={(isClosed) => winOpenChangeByChains(isClosed)} onComplete={fnChosedChain}></DrawerChainsBrc20Com>
    </AssetsSelectWrap>
}

const AssetsSelectWrap = styled(StyledContainer)`
    border-radius: 9px;
    background-color: ${({theme}) => theme.basicWhite};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 10px;

    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);

    &:hover {
        box-shadow: 0px 8px 24px -4px rgba(24, 39, 75, 0.08), 0px 6px 12px -6px rgba(24, 39, 75, 0.12);
    }
`

const ArrowDownSvgWrap = styled(ArrowDownSvg)`
    width: 10px;
    height: 10px;
`
const LeftWrap = styled(Row)`
    padding: 12px 0;
    flex: 2;

    &:hover {
        ${ImgOutWrap} {
            background-color: ${({theme}) => theme.lightPurple};
        }
    }
`

const RightWrap = styled(ColumnCenter)`
    flex: 1;
    border-left: 1px dashed #DFE0E2;
    cursor: pointer;

    &:hover {
        border-color: ${({theme}) => theme.basicPurple};

        ${StyledContainer} {
            color: ${({theme}) => theme.basicPurple};
        }
    }
`

export default AssetsSelectBrc20Com;